var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Sal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#767674;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.1,78.2c-5.5,0-10.2-1.2-14-3.5c-3.9-2.3-6.5-5.6-8-10L38,60.1c0.4,2,1,3.7,1.9,5c0.9,1.3,2.1,2.3,3.6,3 c1.5,0.7,3.3,1,5.5,1c1.9,0,3.5-0.3,4.8-1c1.3-0.7,2.3-1.6,3-2.8c0.7-1.2,1.1-2.6,1.1-4.2s-0.3-2.9-1-4c-0.7-1.1-1.6-1.8-2.9-2.3 c-1.2-0.5-2.8-0.7-4.8-0.7c-0.7,0-1.4,0-2,0S45.8,54,45,54.1v-8.4c0.4,0.1,0.9,0.1,1.4,0.1c0.5,0,1,0,1.5,0c3.1,0,5.3-0.6,6.7-1.9 c1.4-1.2,2-3.3,2-6c0-2.3-0.7-4-2-5.3c-1.4-1.2-3.3-1.9-5.8-1.9c-2.7,0-4.8,0.7-6.3,2c-1.6,1.3-2.6,3.3-3.3,6L29,34.9 c0.7-2.8,2-5.2,3.9-7.2c1.9-2,4.3-3.5,7.1-4.6c2.8-1.1,6-1.6,9.4-1.6c4.1,0,7.5,0.6,10.3,1.9c2.7,1.3,4.8,3,6.2,5.2 c1.4,2.2,2.1,4.8,2.1,7.7c0,2.3-0.3,4.2-1,5.8c-0.7,1.6-1.6,2.9-2.7,4c-1.1,1.1-2.2,1.9-3.4,2.5c-1.2,0.6-2.2,0.9-3.2,1v0.2 c1.3,0.1,2.6,0.3,3.9,0.8c1.3,0.5,2.6,1.2,3.7,2.1c1.1,0.9,2.1,2.2,2.8,3.6c0.7,1.5,1.1,3.2,1.1,5.2c0,3.3-0.9,6.3-2.6,8.8 c-1.8,2.5-4.1,4.5-7.1,5.8C56.5,77.5,53,78.2,49.1,78.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Sal);
export default __webpack_public_path__ + "static/media/3sal.b05b25933b06bbc6a7fd9d292f83a9b1.svg";
export { ForwardRef as ReactComponent };